<template>
    <div class="generic-filter">
          <div class="title-container">
              <p class="title">{{filters.category}}</p>
          </div>
          <div class="checkbox-container">
              <div class="checkbox-button" v-for="categories of filters.filters" :key="categories.category">
                  <input :value="categories.tag" type="checkbox" v-model="activeFilters" @change="changeFilters()">
                  <p>{{categories.value}}</p>
              </div>
          </div>
    </div>
  </template>
  
  <script>
  export default {
        props:{
            filters: Object,
        },
        data() {
                return{
                    true: false,
                    activeFilters: [],
                }
        },
        watch: {
            selectedFilters: {
            handler(val){
                let filter = val.find(x => x.title == this.filters.category);
                if(filter){
                    this.activeFilters = filter.filters;
                }
                else{
                    this.activeFilters = [];
                }
            },
            deep: true
            },
        },
        computed: {
            selectedFilters: {
                get(){ return this.$store.state.selectedFilters },
                set(value){
                    this.$store.commit('setSelectedFilters',  value);
                }
            },
        },
        methods: {
            changeFilters(){
                this.selectedFilters = { title:this.filters.category, filters:this.activeFilters };
            },
        },
        mounted(){
        },
  }
  </script>
  
  <style scoped>
  .generic-filter{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      background-color: white;
      box-shadow: inset 0px -1px 0px #E6E8EC;
  }
  
  .icon{
      cursor: pointer;
  }
  
  .title-container{
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      justify-content: space-between;
      padding: 2% 5%;
  }
  .title{
      color: #0F0C38;
      font-family: 'Karla';
      font-style: normal;
      font-weight: 700;
      font-size: 1.3vw;
      line-height: 1.5;
  }
  
  .checkbox-container{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0% 0% 3% 5%;
      width: 100%;
      overflow: hidden;
  }
  
  .checkbox-button{
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      padding: 1% 0%;
  }
  .checkbox-button input{
      height: unset !important;
  }
  
  .checkbox-button p{
      font-family: 'Karla';
      font-style: normal;
      font-weight: 400;
      font-size: 1.2vw;
      line-height: 1.43;
      color: #0F0C38;
      margin: unset;
  }
  
  .button-container{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      padding: 0% 0% 3% 5%;
      width: 100%;
      overflow: hidden;
      width: 100%;
      justify-content: space-around;
  }
  
  .color-button{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 2% 4%;
      background: #F3F4F6;
      border-radius: 100px;
      width: 45%;
      cursor: pointer;
      margin-bottom: 5%;
  }
  
  .color-button.disabled{
      opacity: 0.6;
  }
  
  .color-button.selected{
      border: 1px solid #0F0C38;
  }
  
  .color-button p{
      font-family: 'Karla';
      font-style: normal;
      font-weight: 400;
      font-size: 1vw;
      line-height: 1.43;
      color: #3F3D60;
      margin-left: 5%;
  }
  
  .round-color{
      width: 1.5vw;
      height: 1.5vw;
      border-radius: 100px;
  }
  
  @media screen and (max-width: 767px){
      .title{
          font-size: 1.2rem;
      }
  
      .icon{
          font-size: 2rem;
      }
  
      .button-container{
          justify-content: flex-start;
      }
  
      .color-button{
          justify-content: space-around;
          width: 30%;
          margin-right: 3%;
      }
  
      .round-color{
          width: 1.5rem;
          height: 1.5rem;
      }
      .checkbox-button p,.color-button p{
          font-size: 1rem;
      }
  }
  </style>